import {
  Component,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  Inject,
  ViewChild,
} from "@angular/core";
import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { Router } from "@angular/router";

// ngrx store
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
// services
import { AppStateService } from '../../../shared/services/app-state.service';
import { LoginService } from "../../../shared/services/login.service";
import { ErrorHandler } from "../../../shared/services/error-handler.service";
import { DataStorageService } from "../../../shared/services/data-storage.service";
import { CopyService } from "../../../shared/services/app-copy.service";
// models
import { AppState } from "../../../booking/models/app-state.interface";
// globals
import { COUNTRY_CODES, EMAIL_PATTERN } from "../../../shared/globals";
import { take } from "rxjs/operators";

declare var ga: any;

@Component({
  selector: "app-account-details",
  templateUrl: "./account-details.component.html",
  styleUrls: ["./account-details.component.scss"],
  providers: [],
})
export class AccountDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('formRegisterDetails') formRegisterDetails;

  private _userSubscription: Subscription;
  private _userUpdateSubscription: Subscription;
  private _userReducerSubscription: Subscription;
  private _utilitySubscription: Subscription;
  private _userLoginValidSubscription: boolean;

  private _dataSavedSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _validatePhoneNumberSubscription: Subscription;
  private _setPasswordSubscription: Subscription;

  private _formValues = null;
  private _subscriptionsSet: Boolean = false;
  private _userChecking: Boolean = false;

  public userHasAccountDetails: Boolean = true;
  public showLoader: Boolean = false;
  public user;
  public countryCode;
  public phonePattern = /^[0-9]*$/;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = "";
  public countryCodes = {
    featured: [...COUNTRY_CODES.featured],
    all: [...COUNTRY_CODES.featured, ...COUNTRY_CODES.all],
  };
  public tokenValue: string;
  private is2FARequired: boolean = false;

  public passwordMatch: Boolean = true;
  public passwordValues: any = {
    password1: "",
    password2: "",
  };
  public emailPattern = EMAIL_PATTERN;
  public namePattern = /^[a-zA-Z]+(?:\s*-\s*[a-zA-Z]+|\s+[a-zA-Z]+)*$/;
  public userEmail;
  showPassword: { [key: string]: boolean } = {
    password: false,
    confirmPassword: false
  };

  public phoneNumberValid = true;

  public passwordStrenghMessage =
    "Your password needs to contain:<br>One capital letter<br>" +
    "One special character<br>One lowercase letter<br>One number<br>8 characters minimum<br>" +
    "Special characters allowed include: @ # $ % ^ *";

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _router: Router,
    private _errorService: ErrorHandler,
    private _dataStorageService: DataStorageService,
    private _copyService: CopyService,
    private _appStateService: AppStateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {


    this._userLanguageSubscription = this._appStore
      .select("copyReducer")
      .subscribe((res: any) => {
        this.selectedLanguage = res.language;
      });

    this._bookingInitSubscription = this._appStore
      .select("loadedStatusReducer")
      .subscribe((res: any) => {

        this.copyLoaded = res.copyLoaded;
        if (res.copyLoaded) {
          this.getCopy();
        }

        if (res.userLoaded && !this._userLoginValidSubscription) {
          if (!this._userLoginValidSubscription) {
            this.setDataSubscriptions();
            this._userLoginValidSubscription = true;
          }
          // after we call checkUser
          // this._userLoginValidSubscription = this._appStateService.userLoginValid$
          //   .subscribe(userOk => {
          //     if (userOk) {
          //     } else {
          //       this._router.navigate(['login']);
          //     }
          //   });

        } else {
          if (!this._userChecking) {
            this._userChecking = true;
            const hasCookieError = this._appStateService.checkUserLogin();
            if (hasCookieError) {
              // this._router.navigate(['login']);
            }
          }

        }
      });

    this.countryCode = "44";

    // Step I :  get token from Email
    this._userReducerSubscription = this._appStore
      .select("userReducer")
      .subscribe((user: any) => {
        this.is2FARequired = user.userDetails.is2FARequired;
        this.tokenValue = user.userDetails.userToken;

        if (user.userDetails.userEmail !== "") {
          this.user = user;

          this.userHasAccountDetails = this.user.userDetails.userHasAccountDetails;
          this.userEmail = user.userDetails.userEmail;
        }
      });

    this._validatePhoneNumberSubscription = this._loginService.validPhoneNumberSubject$
      .subscribe(valid => {
        if (!valid) {
          this.formRegisterDetails.form.controls['UserPhone'].setErrors({ 'incorrect': true });
          this.phoneNumberValid = false;
        } else {
          this.formRegisterDetails.form.controls['UserPhone'].setErrors(null);
          this.phoneNumberValid = true;
        }
      });

    this._setPasswordSubscription = this._loginService.setPasswordSubject$
      .subscribe(res => {

        if (res.error) {
          return;
        }

        if (!res.token) {
          const data = {
            text: "Password set successfully!",
            type: "info",
            icon: "alert",
            sticky: false,
          };

          this._errorService.handleCustomInfo(data);
          this._router.navigate(["login"]);
        }

      })

  }

  togglePasswordVisibility(field: string): void {
    this.showPassword[field] = !this.showPassword[field];
  }
  setDataSubscriptions() {
    this._subscriptionsSet = true;
    this._utilitySubscription = this._appStore
      .select("utilityReducer")
      .subscribe((utility: any) => {
        const loadState = this.getState(this._appStore).loadedStatusReducer

        if (
          !utility.userOTPVerified && !utility.userAccountDetailsUpdate && loadState.storeLoaded && loadState.userLoaded
        ) {
          this._router.navigate(["login"]);
        }
      });

    // Step 3 ; save user details
    this._userSubscription = this._loginService.userSubject$.subscribe(
      (user) => {
        if (user.error) {
          this.handleError();
          return;
        }

        this._loginService.userHasPassword();

        const { Password, PasswordVerify, email, ...values } = this._formValues;

        if (Object.keys(values).length === 0) {
          this.accountDetailsCompleted();
        } else {
          this.handleSubmitRegisterDetails(values);
        }

      },
      (err) => {
        debugger;
        this.showLoader = false;
      }
    );

    this._userUpdateSubscription =
      this._loginService.updateUserSubject$.subscribe((res) => {
        if (res.error) {
          this.handleError();
          return;
        }

        const currentAppState = this.getState(this._appStore);
        const userDetails = currentAppState.userReducer.userDetails;

        const currentUser = userDetails.currentUser;
        const { Password, PasswordVerify, email, ...values } = this._formValues;

        const updatedUser = {
          ...currentUser,
          firstName: values.UserFirstName,
          lastName: values.UserLastName,
          title: values.UserTitle,
          mobileNumber: values.UserPhone,
          mobileNumberCountryCode: values.UserCountryCode,
        };

        console.log('upted data', updatedUser);

        this._appStore.dispatch({ type: "UPDATE_USER", payload: updatedUser });

        this.accountDetailsCompleted();
      });

    this._dataSavedSubscription = this._dataStorageService.dataSaved$.subscribe(
      (res) => {
        if (res) {

          this._router.navigate(["my-account/home"]);
          this.showLoader = false;
        }
      }
    );

  }

  accountDetailsCompleted() {
    const messageData = {
      icon: "tick_in_circle",
      sticky: false,
      type: "success",
      text: "Your details have been saved. You will be re-directed to your account page.",
    };

    this._errorService.handleCustomInfo(messageData);

    this._appStore.dispatch({ type: 'USER_ACCOUNT_UPDATE_STATUS', payload: false });

    if (isPlatformBrowser(this.platformId)) {
      ga("send", "event", "Signup", "Success");
    }

    this._dataStorageService.saveData();
  }

  passwordsEqual(skipOnEmpty = false) {
    let isMatch;

    if (this.passwordValues.password2 === "" && skipOnEmpty) {
      isMatch = true;
      this.passwordMatch = isMatch;
      return;
    }

    if (this.passwordValues.password1 === this.passwordValues.password2) {
      isMatch = true;
    } else {
      isMatch = false;
    }

    this.passwordMatch = isMatch;
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      "OTHER",
      "register",
      ["registerDetailScreen"]
    );
    console.log(panelHeaderCopy);
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };
  }


  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }


  handleError() {
    this.showLoader = false;
  }

  validatePhoneNumber(countryCode, phoneNumber) {
    if (phoneNumber !== '') {
      const value = '+' + countryCode + phoneNumber;
      console.log(value)
      this.handleValidatePhoneNumber(value)
    }
  }

  handleValidatePhoneNumber(data) {
    this.phoneNumberValid = false;
    this._loginService.validatePhoneNumber(data);
  }

  handleSubmitResetPassword(value, e) {
    e.preventDefault();

    this._formValues = value;

    if (this.passwordMatch) {
      this.showLoader = true;

      this.passwordValues = {
        password1: value.Password,
        password2: value.PasswordVerify,
      };

      this.postPasswordChange();
    }
  }

  postPasswordChange() {
    const password = btoa(this.passwordValues.password1);
    // TODO: check for 2FA token , for super admin /admin
    const userPasswordToken = this.getState(this._appStore).userReducer.userDetails.setPasswordUserToken;
    const userToken = this.getState(this._appStore).userReducer.userDetails.userToken;

    const passwordToken = userPasswordToken; // for normal user without details
    const bearerToken = this.is2FARequired ? userToken : (Boolean(userPasswordToken) ? null : userToken); // for admin sedn userToken , other wise check passwrod token

    // works on server
    this._loginService.setPassword(
      this.userEmail,
      password,
      'mmb',
      passwordToken,
      bearerToken,
      this.is2FARequired
    );
  }

  handleSubmitRegisterDetails(value) {
    // e.preventDefault();
    // this.showLoader = true;

    console.log(JSON.stringify(value));
    this._loginService.updateUserAccount(
      value,
      this.user.userDetails.userToken,
      this.user.userDetails.currentUser.userId
    );
  }

  ngOnDestroy() {
    if (this._userReducerSubscription) { this._userReducerSubscription.unsubscribe(); }
    if (this._utilitySubscription) { this._utilitySubscription.unsubscribe(); }
    if (this._dataSavedSubscription) { this._dataSavedSubscription.unsubscribe(); }
    if (this._userSubscription) { this._userSubscription.unsubscribe(); }
    if (this._userUpdateSubscription) { this._userUpdateSubscription.unsubscribe(); }
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
    if (this._bookingInitSubscription) { this._bookingInitSubscription.unsubscribe(); }
    if (this._validatePhoneNumberSubscription) { this._validatePhoneNumberSubscription.unsubscribe(); }
    if (this._setPasswordSubscription) { this._setPasswordSubscription.unsubscribe(); }
  }
}
